import {
  DEPARTMENTS_LIST,
  DEPARTMENT_ADD,
  DEPARTMENT_CHANGE_STATUS,
  DEPARTMENT_DELETE,
  DEPARTMENT_DETAILS,
  DEPARTMENT_EDIT,
} from "../constants/api-path";
import httpClient from "./http.interceptor";

/**
 * @param {page: number, limit: number, sortColumn: string|number, sortDirection: string } formData
 * @returns Promise<any>
 */
export const getAppDepartments = (formData: any): Promise<any> => {
  return httpClient.get(DEPARTMENTS_LIST, {
    params: {
      page: formData.page,
      pageSize: formData.limit,
      sort: formData.sort,
      search: formData.search,
      status: formData.status,
      store: formData.store,
      city: formData.city,
      province: formData.province,
      country: formData.country,
    },
  });
};

export const addAppDepartment = (formData: any): Promise<any> => {
  return httpClient.post(DEPARTMENT_ADD, formData);
};

export const editAppDepartment = (id: string, formData: any): Promise<any> => {
  return httpClient.put(DEPARTMENT_EDIT + id, formData);
};

export const deleteAppDepartment = (id: string): Promise<any> => {
  return httpClient.delete(DEPARTMENT_DELETE + id);
};

export const getAppDepartmentDetails = (id: string): Promise<any> => {
  return httpClient.get(DEPARTMENT_DETAILS + id);
};

export const changeAppDepartmentStatus = (
  id: string,
  status: any,
): Promise<any> => {
  return httpClient.patch(DEPARTMENT_CHANGE_STATUS + id, { status });
};
